// NEVANU Team App — Main Entry Point
// Vite lädt diese Datei und bundelt alle Module

// Core-Module laden und als Globals bereitstellen (Kompatibilität)
import './compat';

// Offline-Datenbank
import { syncAll, processSyncQueue, db, getOfflineTermine, getLastSyncTime, addToSyncQueue, offlineAufraeumen, offlineLoeschen } from './offline/db';

// Native Plugins (Capacitor)
import { initNativePlugins, isNative, getPlatform, takePhoto, hapticLight, hapticMedium, hapticSuccess, hapticError } from './native/plugins';

// Offline-DB auf window (für Legacy-Code)
(window as any).nevanuOffline = {
  db,
  syncAll,
  processSyncQueue,
  getOfflineTermine,
  getLastSyncTime,
  addToSyncQueue,
  aufraeumen: offlineAufraeumen,   // B12: Ablauf
  loeschen: offlineLoeschen,       // B12: beim Abmelden (clearSession, logoutPin)
};

// Native Plugins auf window (für Legacy-Code)
(window as any).nevanuNative = {
  isNative,
  getPlatform,
  takePhoto,
  hapticLight,
  hapticMedium,
  hapticSuccess,
  hapticError,
};

// App-Initialisierung
function initApp(): void {
  // Version-Info im Console
  console.log(
    '%c NEVANU Team %c v2.0.0-pwa ',
    'background:#F27182;color:#fff;padding:4px 8px;border-radius:4px 0 0 4px;font-weight:bold',
    'background:#333;color:#fff;padding:4px 8px;border-radius:0 4px 4px 0'
  );

  // Service Worker registrieren
  if ('serviceWorker' in navigator) {
    // Workbox-generierter SW (aus vite-plugin-pwa Build)
    const swUrl = '/sw.js';
    navigator.serviceWorker.register(swUrl)
      .then(reg => {
        console.log('[NEVANU] Service Worker registriert, scope:', reg.scope);
        (window as any).__SW_REGISTERED = true;

        // Auf Updates prüfen
        reg.addEventListener('updatefound', () => {
          const newWorker = reg.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'activated') {
                console.log('[NEVANU] Neuer Service Worker aktiviert — Seite neu laden für Updates');
              }
            });
          }
        });
      })
      .catch(err => {
        console.log('[NEVANU] SW Registrierung fehlgeschlagen:', err);
      });
  }

  // Native Plugins initialisieren (Capacitor)
  initNativePlugins().catch(e => console.warn('[NEVANU] Native-Init fehlgeschlagen:', e));

  // Offline-Sync starten (nach Login, verzögert)
  setTimeout(() => {
    const session = localStorage.getItem('nevanu_session') || localStorage.getItem('nevanuSession');
    if (session) {
      syncAll().catch(e => console.warn('[NEVANU] Initial-Sync fehlgeschlagen:', e));
    } else {
      // B12: niemand angemeldet → keine Offline-Kopie auf dem Gerät (auch nach einer abgelaufenen Sitzung)
      offlineLoeschen().catch(() => {});
    }
  }, 3000); // 3s Delay damit Dashboard zuerst lädt

  // Online/Offline Events
  window.addEventListener('online', () => {
    console.log('[NEVANU] Online — Sync starten');
    const indicator = document.getElementById('offline-indicator');
    if (indicator) indicator.style.display = 'none';
    syncAll().catch(() => {});
  });

  window.addEventListener('offline', () => {
    console.log('[NEVANU] Offline — lokale Daten verfügbar');
    showOfflineIndicator();
  });

  // Initial Offline-Check
  if (!navigator.onLine) {
    showOfflineIndicator();
  }
}

/** Offline-Indikator anzeigen */
function showOfflineIndicator(): void {
  let indicator = document.getElementById('offline-indicator');
  if (!indicator) {
    indicator = document.createElement('div');
    indicator.id = 'offline-indicator';
    Object.assign(indicator.style, {
      position: 'fixed',
      top: 'env(safe-area-inset-top, 0)',
      left: '0',
      right: '0',
      background: '#F27182',
      color: '#fff',
      textAlign: 'center',
      padding: '6px 16px',
      fontSize: '.78rem',
      fontWeight: '600',
      fontFamily: 'Outfit, sans-serif',
      zIndex: '99999',
      letterSpacing: '1px',
    });
    indicator.textContent = '✈ OFFLINE — Lokale Daten werden verwendet';
    document.body.prepend(indicator);
  }
  indicator.style.display = 'block';
}

// DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initApp);
} else {
  initApp();
}
